import { mutate } from '../apollo-client';
import {
  AdminGameGenerateFakeLeaderboardDataInput,
  ADMIN_GAME_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION,
  AdminGameGenerateFakeLeaderboardDataMutationResponse,
} from '@crazygames/graph-types/game/admin-game-generate-fake-leaderboard-data.type';

export function generateFakeLeaderboardDataForGame(input: AdminGameGenerateFakeLeaderboardDataInput) {
  return mutate<AdminGameGenerateFakeLeaderboardDataInput, AdminGameGenerateFakeLeaderboardDataMutationResponse>(
    ADMIN_GAME_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION,
    input,
  );
}
